import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { UtilsService } from '../../services/utils.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.css']
})
export class DeleteComponent implements OnInit {

  public enableDeleteButton: boolean = false;
  private destroy$ = new Subject();

  constructor(public _data: DataService,
    private _utils: UtilsService,
    private _blogic: BusinesLogicService) { }

  ngOnInit() {
    this._selectedUpdateTurn(this._data.selectedTurn);
    this._data.selectedTurnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._selectedUpdateTurn(response);
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private deleteTurn() {

    let params: object = [];

    params = {
      turn_id: this._data.selectedTurn["id"]
    };

    this._blogic.deleteTurn(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          $("#refreshList").trigger('click');
        }
      );
  }

  /* When the turn information change */
  private _selectedUpdateTurn(selectedTurn: object): void {
    if (selectedTurn != null && (selectedTurn['type'] == 'inWait' || selectedTurn['type'] == 'noShow' || selectedTurn['type'] == 'cancelled')) {
      this.enableDeleteButton = true;
    } else {
      this.enableDeleteButton = false;
    }
  }

}
